import React from 'react';
import ChatDetailBlock from '@/views/event_detail/ChatDetailBlock';
import {ChatEvent} from 'entities/event';

interface Props {
    eventData: ChatEvent;
}

const ChatTextSamplesModalContents = React.memo<Props>(({eventData}) => (
    <ChatDetailBlock eventData={eventData} />
));

export default ChatTextSamplesModalContents;
